import { last } from 'gleam-shared/helpers/nodash'
import { MIN_ERROR_STATUS } from 'gleam-shared/network/statusCodes'
import toServerError from 'gleam-shared/network/toServerError'

export const FRESH_FOR = 600_000 // 10 min

let retrievedAt = null
let cookiesDisabled = false

export function retestCookies() {
  cookiesDisabled = false
}

export function expireCSRF() {
  retrievedAt = null
}

export default function retrieveCSRF() {
  if (!navigator.cookieEnabled || cookiesDisabled) {
    return Promise.resolve()
  }

  const csrfToken = freshCSRF()

  if (csrfToken) {
    return Promise.resolve(csrfToken)
  }

  return fetch('/csrf').then((response) => {
    if (response.status >= MIN_ERROR_STATUS) {
      return Promise.reject(toServerError(response))
    }

    return expectFreshCSRF()
  })
}

function expectFreshCSRF() {
  const csrfToken = getCSRF()

  if (csrfToken) {
    makeFresh()
    return csrfToken
  } else {
    console.warn('A fresh security token could not be retrieved! Please try to relax your browser\'s Cookies restrictions.')
    cookiesDisabled = true
  }
}

function freshCSRF() {
  if (isFresh()) {
    return getCSRF()
  }
}

function getCSRF() {
  return last(/XSRF-TOKEN=(.*?)(?=;|$)/.exec(globalThis.document?.cookie))
}

function isFresh() {
  return retrievedAt !== null && (performance.now() - retrievedAt) < FRESH_FOR
}

function makeFresh() {
  retrievedAt = performance.now()
}
